import store from '@/store'
import { getDataFiles } from '@/functions/extractData.js'

const re_array= /\[(.*)\]/
const re_all_elements = /all/i

function addToTerminal(type, text){
  store.commit('ADD_MESSAGE_TERMINAL_SECTION', {
    type:type,
    text:text
  })
}

async function getDictionaryDatalines(){
  if(Object.entries(store.getters.getCurrentReportViewer).length === 0){
    addToTerminal('ERROR', 'Please load a report before executing the command')
    return null
  }
  const dataFiles = await getDataFiles(store.getters.getCurrentReportViewer)
  const dictDatalines = {}
  for(let j=0;j<dataFiles.length;j++){
    const extracted = dataFiles[j].extractedData
    for(let n=0;n<extracted.length;n++){
      dictDatalines[`${j}.${n}`] = extracted[n]
    }
  }
  if(Object.entries(dictDatalines).length === 0){
    addToTerminal('ERROR', 'The report opened in the Report Vierwer does not have datalines to flip.')
    return null
  }
  return dictDatalines
}

function flip_exec(property, elements, dictDatalines){
  for(let elem of elements){
    if(typeof(dictDatalines[elem])==='undefined'){
      addToTerminal('ERROR', `Element '${elem}' not identified. Please use the id of the Processed Data table`)
      continue
    }
    store.commit('SET_ALL_CONFIG_MODIFIED_ReportViewer')
    const dataline = dictDatalines[elem]
    if(typeof(dataline[property]) === 'undefined'){
      dataline[property] = true
    }else{
      delete dataline[property]
    }
  }
  store.getters.getCurrentReportViewer.forceUpdateWhenOpen = true
}

function addPropertyDatalines(property, elements, propVal, dictDatalines){
  for(let elem of elements){
    if(typeof(dictDatalines[elem])==='undefined'){
      addToTerminal('ERROR', `Element '${elem}' not identified. Please use the id of the Processed Data table`)
      continue
    }
    store.commit('SET_ALL_CONFIG_MODIFIED_ReportViewer')
    const dataline = dictDatalines[elem]
    dataline[property] = propVal
  }
  store.getters.getCurrentReportViewer.forceUpdateWhenOpen = true
}

async function addProperty(args, actionStr, property, axisStr){
  // Get the dictionary of the datalines the key is the id of the processed files    
  const dictDatalines = await getDictionaryDatalines()
  if(dictDatalines === null){
    return false
  }

  //Get the elements to add the property
  const argsFormatted = args.replace(' ','')
  const array_match = re_array.exec(argsFormatted)
  if(array_match !== null){
    //First remove the elements detected in array
    const propertyVal = getPropValue(argsFormatted, array_match[0], actionStr)
    if(propertyVal === null){
      return false
    }
    addToTerminal('INFO', `Setting the ${actionStr} '${propertyVal}' the selected items on the ${axisStr} axis...`)
    addPropertyDatalines(property, array_match[1].split(','), propertyVal, dictDatalines)
  }else if(re_all_elements.test(argsFormatted)){
    const propertyVal = getPropValue(argsFormatted, re_all_elements.exec(argsFormatted)[0], actionStr)
    if(propertyVal === null){
      return false
    }
    addToTerminal('INFO', `Setting the ${actionStr} '${propertyVal}' all the items on the ${axisStr} axis...`)
    addPropertyDatalines(property, Object.keys(dictDatalines), propertyVal, dictDatalines)
  }else{
    const propertyVal = getPropValue(argsFormatted, '', actionStr)
    if(propertyVal === null){
      return false
    }
    addToTerminal('INFO', `Setting the ${actionStr} '${propertyVal}' the element ${argsFormatted.split(',')[0]} on the ${axisStr} axis...`)
    addPropertyDatalines(property, [argsFormatted.split(',')[0]], propertyVal, dictDatalines)
  }
  addToTerminal('INFO', 'Done.\n')
  return true
}

function getPropValue(command, strRemove, strAction){
  const remove_elements = strRemove!==''?command.replace(strRemove,''):command
  const value_split = remove_elements.split(',')
  if(value_split.length !== 2){
    addToTerminal('ERROR', `Please provide a single element for the ${strAction} after the selected items. Execute the help with this command as argument for more assistance.`)
    return null
  }
  const valueFloat = parseFloat(value_split[1])
  if(isNaN(valueFloat)){
    addToTerminal('ERROR', `The value '${value_split[1]}' is not a valid number`)
    return null
  }
  return valueFloat
}

function showPropertyChanges(dictDatalines, actionStr, property, axisStr, boolValue){
  let prop_array = []
  for (const [key, value] of Object.entries(dictDatalines)) {
    if(typeof(value[property]) !== 'undefined' && (!boolValue || value[property])){
      prop_array.push(`${key}(${value[property]})`)
    }
  }
  if(prop_array.length > 0){
    addToTerminal('INFO', `Elements with ${axisStr} ${actionStr}: ${prop_array.join(', ')}.`)
    return true
  }
  return false
}

async function cleanPropertyType(typeStr, xkey, ykey){
  const dictDatalines = await getDictionaryDatalines()
  if(dictDatalines === null){
    return false
  }
  const propYArray = []
  const propXArray = []
  for (const [key, value] of Object.entries(dictDatalines)) {
    if(typeof(value[ykey]) !== 'undefined'){
      propYArray.push(`${key}(${value[ykey]})`)
      delete value[ykey]
    }
    if(typeof(value[xkey]) !== 'undefined'){
      propXArray.push(`${key}(${value[xkey]})`)
      delete value[xkey]
    }
  }
  if(propYArray.length > 0){
    addToTerminal('INFO', `${typeStr} in y removed for the elements: ${propYArray.join(', ')}.`)
  }
  if(propXArray.length > 0){
    addToTerminal('INFO', `${typeStr} in x removed for the elements: ${propXArray.join(', ')}.`)
  }
  addToTerminal('INFO', 'Done.\n')
  return true
}

export default {
  async flipx(parent,args){
    // Get the dictionary of the datalines the key is the id of the processed files    
    const dictDatalines = await getDictionaryDatalines()
    if(dictDatalines === null){
      return false
    }

    //Get the elements to apply the flipx
    const argsFormatted = args.replace(' ','')
    const array_match = re_array.exec(argsFormatted)
    if(array_match !== null){
      addToTerminal('INFO', 'Flipping the selected items on the x axis...')
      flip_exec('flipx', array_match[1].split(','), dictDatalines)
    }else if(re_all_elements.test(argsFormatted)){
      addToTerminal('INFO', 'Flipping all the items on the x axis...')
      flip_exec('flipx', Object.keys(dictDatalines), dictDatalines)
    }else{
      addToTerminal('INFO', `Flipping the element ${argsFormatted} on the x axis...`)
      flip_exec('flipx', [argsFormatted], dictDatalines)
    }
    addToTerminal('COMMAND', 'Done.\n')
    return true
  },
  async flipy(parent,args){
    // Get the dictionary of the datalines the key is the id of the processed files    
    const dictDatalines = await getDictionaryDatalines()
    if(dictDatalines === null){
      return false
    }

    //Get the elements to apply the flipy
    const argsFormatted = args.replace(' ','')
    const array_match = re_array.exec(argsFormatted)
    if(array_match !== null){
      addToTerminal('INFO', 'Flipping the selected items on the y axis...')
      flip_exec('flipy', array_match[1].split(','), dictDatalines)
    }else if(re_all_elements.test(argsFormatted)){
      addToTerminal('INFO', 'Flipping all the items on the y axis...')
      flip_exec('flipy', Object.keys(dictDatalines), dictDatalines)
    }else{
      addToTerminal('INFO', `Flipping the element ${argsFormatted} on the y axis...`)
      flip_exec('flipy', [argsFormatted], dictDatalines)
    }
    addToTerminal('INFO', 'Done.\n')
    return true
  },
  offsetx(parent,args){
    addProperty(args, 'offset', 'offsetx', 'x')
  },
  offsety(parent,args){
    addProperty(args, 'offset', 'offsety', 'y')
  },
  scalex(parent,args){
    addProperty(args, 'scale', 'scalex', 'x')
  },
  scaley(parent,args){
    addProperty(args, 'scale', 'scaley', 'y')
  },
  async showChanges(){
    const dictDatalines = await getDictionaryDatalines()
    if(dictDatalines === null){
      return false
    }
    let changeFound = showPropertyChanges(dictDatalines, 'offset', 'offsety', 'y', false)
    changeFound = showPropertyChanges(dictDatalines, 'offset', 'offsetx', 'x', false) || changeFound
    changeFound = showPropertyChanges(dictDatalines, 'flip', 'flipx', 'x', true) || changeFound
    changeFound = showPropertyChanges(dictDatalines, 'flip', 'flipy', 'y', true) || changeFound
    changeFound = showPropertyChanges(dictDatalines, 'scale', 'scalex', 'x', false) || changeFound
    changeFound = showPropertyChanges(dictDatalines, 'scale', 'scaley', 'y', false) || changeFound
    // If any change found then notify the user
    if(!changeFound){
      addToTerminal('INFO', 'No changes found in the current report.')
    }
    addToTerminal('INFO', 'Done.\n')
    return true
  },
  async cleanOffset(){
    return await cleanPropertyType('Offset', 'offsetx', 'offsety')
  },
  async cleanScale(){
    return await cleanPropertyType('Scale', 'scalex', 'scaley')
  },
  async cleanFlip(){
    const dictDatalines = await getDictionaryDatalines()
    if(dictDatalines === null){
      return false
    }
    const flipy_array = []
    const flipx_array = []
    for (const [key, value] of Object.entries(dictDatalines)) {
      if(typeof(value.flipx) !== 'undefined' && value.flipx){
        flipx_array.push(`${key}`)
        delete value.flipx
      }
      if(typeof(value.flipy) !== 'undefined' && value.flipy){
        flipy_array.push(`${key}`)
        delete value.flipy
      }
    }
    if(flipy_array.length > 0){
      addToTerminal('INFO', `Flip in y axis removed for elements: ${flipy_array.join(', ')}.`)
    }
    if(flipx_array.length > 0){
      addToTerminal('INFO', `Flip in x axis removed for elements: ${flipx_array.join(', ')}.`)
    }
    addToTerminal('INFO', 'Done.\n')
    return true
  },
}